// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesFilters-cls1_C0U","cls2":"ArticlesFilters-cls2_Jsd ArticlesFilters-cls1_C0U"};